export const saleTypes = [
    {
        title: 'For Sale',
        heroTitle: 'Sale',
        value: 'sale'
    },
    {
        title: 'For Rent',
        heroTitle: 'Rent',
        value: 'rent'
    }
]